import { render, staticRenderFns } from "./Line.vue?vue&type=template&id=67baabfa&scoped=true&"
var script = {}
import style0 from "./Line.vue?vue&type=style&index=0&id=67baabfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67baabfa",
  null
  
)

export default component.exports